/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default async function access(initialState?: { roles?:any[], authButton?: any}) {
  let permissions:any = {}
  if (initialState?.authButton) {
    permissions = initialState?.authButton?.data
  }
  const login = localStorage.getItem('token') || null
  return {
    login: login,
    canReadButton: (routeName: string) => {
      if (permissions === '*:*:*') {
        return true
      }
      return permissions?.includes(routeName)
    }
  };
}
